// import { getUserBasket } from '../../helpers/localStorage'
export default {
  myBasket: (state) => {
    if (state.isMassBooking && state.campaignMassBook) {
      return state.items.map((basket) => {
        const newBasket = JSON.parse(JSON.stringify(basket))
        Object.assign(newBasket, { campaign: state.campaignMassBook })
        Object.assign(newBasket.bookingData, {
          campaign: state.campaignMassBook,
        })
        return newBasket
      })
    }
    return state.items
  },
  isShowBasketOverlay: (state) => {
    return state.isShowBasketOverlay
  },
  myDeliveryAddresses: (state) => {
    return state.deliveryAddresses
  },
  storeAddressTo: (state) => {
    return state.storeAddressTo
  },
  getDiscount: (state) => {
    return state.discount
  },
  isPaidBasket: (state) => {
    return state.isPaidBasket
  },
  basketDisplay: (state) => {
    return state.basketData
  },
  delierySelected: (state) => {
    return state.delierySelectedAddress
  },
}
